import { render, staticRenderFns } from "./assetsImgOther.vue?vue&type=template&id=1c898a18&scoped=true&"
import script from "./assetsImgOther.vue?vue&type=script&lang=js&"
export * from "./assetsImgOther.vue?vue&type=script&lang=js&"
import style0 from "./assetsImgOther.vue?vue&type=style&index=0&id=1c898a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c898a18",
  null
  
)

export default component.exports